export default "__VITE_ASSET__CiT_Hyed__"